export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-500px-4dbb6f03b0f3affe58fb30fed36869fe.svg";